import React, { useContext, useEffect, useState } from "react";
import InputDropdown from "../../../CommonComponents/InputDropdown";
import Button from "../../../Button";
import useAxiosPrivate from "../../../../Hooks/useAxiosPrivate";
import AlertContext from "../../../../context/AlertContext";
import constants from "../../../../constants";

const RecommendedPopup = ({ onCancel, onSave }) => {
  const { setShowNotify, setIsLoaded } = useContext(AlertContext);
  const axios = useAxiosPrivate();

  const [companies, setCompanies] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState(null);

  const onSaveDetails = () => {
    if (onSave) onSave(selectedCompany);
  };

  useEffect(() => {
    const fetchCompanies = async () => {
      setIsLoaded(true);
      try {
        const response = await axios.get(
          `node/admin/company/profile?acctype=${constants.ACCOUNT_USAGE_TYPE.HIRING}`,
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
        if (response.data.resultCode === constants.RESULT_STATUS.SUCCESS) {
          let data = response.data.data ?? [];
          setCompanies(
            data.map((item) => ({ value: item.company_id, label: item.name }))
          );
        } else {
          setShowNotify({
            show: true,
            title: "Error!",
            msg:
              response.data.msg ??
              "Something went wrong. Please try again later or contact gradious team.",
          });
        }
      } catch (error) {
        console.error("Error fetching companies:", error);
        setShowNotify({
          show: true,
          title: error.message.includes("403") ? "Warning!" : "Error!",
          msg: error.message.includes("403")
            ? "You have been logged-out due to inactivity. Login again."
            : error.message ??
              "Something went wrong. Please try again later or contact gradious team.",
          isUnAuth: error.message.includes("403"),
        });
      } finally {
        setIsLoaded(false);
      }
    };
    fetchCompanies();
  }, [axios, setShowNotify, setIsLoaded]);

  return (
    <div className="recPopupContainer">
      <div className="">
        <InputDropdown
          label="Recommend Students"
          placeholder="Select Client"
          options={companies}
          value={selectedCompany}
          onChange={(value) => setSelectedCompany(value)}
        />
      </div>
      <div className="recPopupBtnSec">
        <Button
          size="sm"
          hierarchy={{ type: "secondaryGrey", buttonText: "Cancel" }}
          onClick={onCancel}
        />
        <Button
          size="sm"
          disable={!selectedCompany}
          hierarchy={{ type: "primary", buttonText: "Save" }}
          onClick={onSaveDetails}
        />
      </div>
    </div>
  );
};

export default RecommendedPopup;
